export const CheckPermission = (permission, allow) => {
  let permissionObj = JSON.parse(localStorage.getItem("userPermissions"));
  let singlePermission = Object.keys(permissionObj)
    .filter((key) => key.includes(permission))
    .reduce((cur, key) => {
      return Object.assign(cur, { [key]: permissionObj[key] });
    }, {});

  if (singlePermission) {
    let obj = Object?.values(singlePermission)[0];
    if (Object?.keys(obj)?.includes(allow) && obj[allow] == 1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
